import type { AssignmentFilter, Incident, IncidentTask, UserAssignment, UserRole } from './types/incident';

export const roleLabelKey = (role: UserRole): string => `incident.role.${role}`;

export const assignmentMatchesIncident = (assignment: UserAssignment, incident: Incident): boolean => {
  if (assignment.role === 'SERVICE') {
    return true;
  }
  if (assignment.role === 'QUALITY') {
    return true;
  }
  if (assignment.role === 'ISSUING_PARTY') {
    return true;
  }
  if (assignment.role === 'ORG_ADMIN') {
    return true;
  }
  if (assignment.role === 'SYSTEM_ADMIN') {
    return true;
  }
  return false;
};

export const filterIncidentsByAssignment = (
  incidents: Incident[],
  assignments: UserAssignment[],
  filter: AssignmentFilter
): Incident[] => {
  if (filter === 'ALL') return incidents;
  const assignment = assignments.find((item) => item.id === filter);
  if (!assignment) return incidents;
  return incidents.filter((incident) => assignmentMatchesIncident(assignment, incident));
};

export const assignmentRoles = (assignments: UserAssignment[]): UserRole[] =>
  Array.from(new Set(assignments.map((assignment) => assignment.role)));

export const canCreateIncident = (assignments: UserAssignment[]): boolean =>
  assignments.some((assignment) => ['ISSUING_PARTY', 'ORG_ADMIN', 'SYSTEM_ADMIN'].includes(assignment.role));

export const canEditIncident = (assignments: UserAssignment[]): boolean =>
  canCreateIncident(assignments);

export const canCloseIncident = (assignments: UserAssignment[], incident: Incident): boolean =>
  incident.status === 'RESOLVED' && canCreateIncident(assignments);

export const canEditTask = (assignments: UserAssignment[], task: IncidentTask): boolean => {
  if (assignments.some((assignment) => ['ORG_ADMIN', 'SYSTEM_ADMIN'].includes(assignment.role))) {
    return true;
  }
  return assignments.some((assignment) => assignment.role === task.responsible_role);
};
